import { render, staticRenderFns } from "./TableLanguages.vue?vue&type=template&id=10be660a&scoped=true"
import script from "./TableLanguages.vue?vue&type=script&lang=js"
export * from "./TableLanguages.vue?vue&type=script&lang=js"
import style0 from "./TableLanguages.vue?vue&type=style&index=0&id=10be660a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10be660a",
  null
  
)

export default component.exports